<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
      <!-- <div class="h-topo_pw"> -->

      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
          <span :class="['icon hero-icon '+icon+ ' '+online]"></span>
        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.neName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_wytb_wz">
            <table class="h-topo_tableheight">
              <tr>
                <td>{{$t('TS.neID')}}: {{devInfo.id}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.neType')}}: {{typeCode}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.neDev')}}: {{devInfo.equipmentName}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devIp')}}: {{devInfo.equipmentIP}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devPort')}}: {{devInfo.equipmentPort}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.physicalIP')}}: {{devInfo.physicalIP}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.physicalPort')}}: {{devInfo.physicalPort}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="h-topo_btnbox">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
        </div>
      </div>
    </div>
    <!-- “告警弹窗展示” -->
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
import { EventBus } from '../../plugins/eventBus';

export default {
  name: "NePanelBoardShow",
  components: {
    CustomDialog,
    AlarmShowDialog
  },
  data() {
    return {
      alarmDetailObj: { id: this.id},
      typeData: [],
      typeCode: "",
      icon: "",
      online: "",
      devInfo: {},
      see: false,
      seeBottom: false,
      id: "",
      type: "",
      //-- view to left or right
      PositionXY: '',
      oprSetDialog: {
        element: {
          title: this.$t("Alarm.alarm"),
          target: "#app",
          isClose: true,
          refName: "oprSetDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: this.$t("Alarm.confirm") }
            }
          ]
        },
        styles: {
          width: "810px",
          height: "760px",
          model: true,
          visible: false,
        }
      }
    };
  },
  props: ["neAlarmShowObj"],
  methods: {
    panelBoardGetData() {
      this.axios
        .get(`/lte/ems/topo/ne/findNeDetail/${this.id}`)
        .then(response => {
          if (response.status === 200) {
            this.devInfo = response.data.resultVal;
          }
        });
    },

    // 去后台查网元类型
    queryNeType(typeCode) {
      const This = this;
      This.$axios.get("/lte/ems/topo/ne/findNeType").then(response => {
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          This.typeData = response.data.resultVal;
          for (let index in This.typeData) {
            if (This.typeData[index].typeCode == typeCode) {
              this.typeCode = This.typeData[index].nameKey;
              this.icon = This.typeData[index].icon;
            }
          }
        } else if (response.status === 401){
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    click() {
      this.seeBottom = !this.seeBottom;
      this.see = !this.see;
    },

    alarmShowOperation() {
     this.$refs.oprDialog.show();
     var alarmId=this.id
     this.$refs.alarmDetailDialog.beforeMount(alarmId);

    },
    dialogHide() {
      this.$refs.oprDialog.clear();
      this.$refs.oprDialog.close();
    }
  },

  mounted() {},
  // 当鼠标移动时触发
  touchmove(e) {
        console.error('touchmove');
  },
  watch: {
    //父子动态传值
    neAlarmShowObj: {
      handler: function(newVal, oldVal) {
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;
        this.type = newVal.typeObj;
        if(newVal.onlineObj===1){
         	this.online='h-pm-iconOnline';
        }       
        else if(newVal.onlineObj===0){
         	this.online='h-pm-iconOffline';
        }
        this.PositionXY = newVal.PositionXY;
        this.panelBoardGetData();
        this.queryNeType(this.type);
      },
      deep: true
    }
  }
};
</script>

